<div class="flex">
  <div class="col-seleccion shrink-0">
    <ticketing-stepper></ticketing-stepper>
    <router-outlet></router-outlet>
  </div>

  <ticketing-resumen-compra></ticketing-resumen-compra>
</div>
